import { useMemo } from "react";
import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import { Loader } from "rsuite";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import { BsBoxArrowInUpRight } from "react-icons/bs";
import ModalMuiTable from "../../../Components/Modals/ModalCollabaxMuiTable .jsx";

const manpowerApi = async (body) => {
  try {
    const res = await axInst.post("dealer-review/manpower_data", body);
    return res.data;
  } catch (error) {
    console.error("Error fetching manpower data:", error);
    throw error;
  }
};

const ManpowerTable = ({ show }) => {
  const { data, submitted } = useSelector((e) => e.filtersDealerReview);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalApi, setModalApi] = useState("");
  const [modalHeading, setModalHeading] = useState("");

  const {
    data: manpowerData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["manpower", submitted],
    queryFn: () => manpowerApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  const columns = [
    {
      header: "",
      accessorKey: "Product_Line",
      id: "product_line",
    },
    {
      header: "DSM",
      columns: [
        {
          id: "dsm_agreed",
          header: "Target",
          accessorFn: (row) => row?.DSM?.agreed_dsm ?? "NA",
        },
        {
          id: "dsm_actual",
          header: "Actual",
          accessorFn: (row) => row?.DSM?.actual_dsm ?? "NA",
        },
        {
          id: "dsm_gap",
          header: "Gap",
          accessorFn: (row) => row?.DSM?.dsm_gap ?? "NA",
        },
      ],
    },
    {
      header: "DSE",
      columns: [
        {
          id: "dse_agreed",
          header: "Target",
          accessorFn: (row) => row?.DSE?.agreed_dse ?? "NA",
        },
        {
          id: "dse_actual",
          header: "Actual",
          accessorFn: (row) => row?.DSE?.actual_dse ?? "NA",
        },
        {
          id: "dse_gap",
          header: "Gap",
          accessorFn: (row) => row?.DSE?.dse_gap ?? "NA",
        },
      ],
    },
    {
      header: "NDRM",
      columns: [
        {
          id: "ndrm_agreed",
          header: "Target",
          accessorFn: (row) => row?.NDRM?.agreed_ndrm ?? "NA",
        },
        {
          id: "ndrm_actual",
          header: "Actual",
          accessorFn: (row) => row?.NDRM?.actual_ndrm ?? "NA",
        },
        {
          id: "ndrm_gap",
          header: "Gap",
          accessorFn: (row) => row?.NDRM?.ndrm_gap ?? "NA",
        },
      ],
    },
    {
      header: "NSE",
      columns: [
        {
          id: "nse_agreed",
          header: "Target",
          accessorFn: (row) => row?.NSE?.agreed_nse ?? "NA",
        },
        {
          id: "nse_actual",
          header: "Actual",
          accessorFn: (row) => row?.NSE?.actual_nse ?? "NA",
        },
        {
          id: "nse_gap",
          header: "Gap",
          accessorFn: (row) => row?.NSE?.nse_gap ?? "NA",
        },
      ],
    },
    {
      header: "BDE",
      columns: [
        {
          id: "bde_agreed",
          header: "Target",
          accessorFn: (row) => row?.BDE?.agreed_bde ?? "NA",
        },
        {
          id: "bde_actual",
          header: "Actual",
          accessorFn: (row) => row?.BDE?.actual_bde ?? "NA",
        },
        {
          id: "bde_gap",
          header: "Gap",
          accessorFn: (row) => row?.BDE?.bde_gap ?? "NA",
        },
      ],
    },
  ];

  const handleOpenModal = (api, heading) => {
    setModalApi(api);
    setModalHeading(heading);
    setIsModalOpen(true);
  };

  const tableData = useMemo(() => manpowerData || [], [manpowerData]);

  const table = useReactTable({
    data: tableData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );

  if (isError) return <div>Error loading data.</div>;

  if (!tableData || tableData.length === 0)
    return (
      <div className="grid items-center justify-center w-full h-full">
        Data not Available
      </div>
    );

  return (
    <>
      <div className="relative shadow-lg rounded-lg pt-2 bg-white mt-2 md:mt-0">
        <WaterMark />
        <div className="flex justify-between px-2">
          <div className="text-lg font-bold text-gray-800">Manpower</div>
          {!show && (
            <div
              onClick={() =>
                handleOpenModal("dealer-review/region_manpower_new", "Manpower")
              }
              className="text-sm flex items-center gap-2 mb-2 cursor-pointer bg-[#28526e] hover:bg-[white] hover:text-[#28526e] hover:border hover:border-[#28526e] p-1 rounded-md text-white border border-[#28526e]"
              title="Click to View Detail Manpower Report"
            >
              Manpower Detailed Summary{" "}
              <BsBoxArrowInUpRight className="blink" />
            </div>
          )}
        </div>
        <div className="drilltable overflow-auto">
          <table className="w-full border-collapse border border-[#B9B9B9]">
            <thead className="bg-[#28526E] text-white text-xs">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th
                      key={header.id}
                      className="border border-[#B9B9B9] text-center px-2 py-1"
                      colSpan={header.colSpan}
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell, index) => (
                    <td
                      key={cell.id}
                      className={`border border-[#EEF0F5] text-center text-xs px-2 py-[7px] ${
                        index === 0 ? "bg-[#D4E1EC]" : ""
                      }`}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && (
        <ModalMuiTable
          open={isModalOpen}
          heading={modalHeading}
          apiEndpoint={modalApi}
          sliceName={"filtersPipeline"}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default ManpowerTable;
